import { CenterFlex } from "@root/components/dashboard/chat/style";
import { CustomText } from "../components";
import { FlexProps } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export default function NoRecordsText({ ...props }: FlexProps) {
  const { t } = useTranslation("common");
  return (
    <CenterFlex p={"16px"} width={"100%"} mt={"35vh"} {...props}>
      <CustomText text={t("mainTable.noRecordsFound")} />
    </CenterFlex>
  );
}
